import type { JSX } from 'react'
import { getDashBoardIcon, getPanesCount } from '../../../util/widgetDashboard'
import { MultiPaneItem } from '../../multiPane/multiPaneLayout.interface'
import { PredefinedDashboard } from '../widgetDashboard.enums'
import { WidgetDashboardConfig } from '../widgetDashboard.interface'

export default class DashboardWrapper {
    id: PredefinedDashboard
    icon: JSX.Element
    panesCount: number
    dashboardConfig: WidgetDashboardConfig | undefined

    constructor(id: PredefinedDashboard) {
        this.id = id
        this.icon = getDashBoardIcon(id)
        this.panesCount = getPanesCount(id)
    }

    slots(): number[] {
        const singlePanes = this._getSinglePanes()
        return singlePanes.map((sp: MultiPaneItem) => sp.id)
    }

    applyPreviousSlots(prevSlots: number[]) {
        if (!this.dashboardConfig) return
        const ps = new Set(prevSlots)
        const pane: MultiPaneItem = JSON.parse(JSON.stringify(this.dashboardConfig.panes))
        let slot: number = 1
        const singlePanes: MultiPaneItem[] = []
        const que: MultiPaneItem[] = [pane]
        while (que.length) {
            const topPane = que.shift()!
            if (!topPane.panes.length) {
                singlePanes.push(topPane)
            } else {
                while (ps.has(slot)) {
                    slot++
                }
                topPane.id = slot
                slot++
                topPane.panes.forEach((pn) => que.push(pn))
            }
        }
        singlePanes.forEach((sp, ind) => {
            if (ind < prevSlots.length) {
                sp.id = prevSlots[ind]
            } else {
                while (ps.has(slot)) {
                    slot++
                }
                sp.id = slot
                slot++
            }
        })
        this.dashboardConfig = {
            ...this.dashboardConfig,
            panes: pane
        }
    }

    private _getSinglePanes(): MultiPaneItem[] {
        if (!this.dashboardConfig) return []
        const pane: MultiPaneItem = this.dashboardConfig.panes
        const singlePanes: MultiPaneItem[] = []
        const que: MultiPaneItem[] = [pane]
        while (que.length) {
            const topPane = que.shift()!
            if (!topPane.panes.length) {
                singlePanes.push(topPane)
            } else {
                topPane.panes.forEach((pn) => que.push(pn))
            }
        }
        return singlePanes
    }

}

